import React from "react";
import styled, { css } from "styled-components";
import { Button } from "react-bootstrap";

const LoginButton = styled(Button)`
    padding-top: 15px !important
    padding-bottom: 15px !important
    border-radius: 15px !important
    background: #094ce5
    border-bottom-color: #5080ed !important
    border-bottom-width: 12px !important
    width: 100%
    opacity: 1
    background-color: #094ce5 !important
    > span {
        font-size: 1.5em !important
        font-weight: bold
    }
    :hover{
        background: #094ce5
    }
    :focus{ }
    ${(props) => {
      if (props.loading) {
        return css`
            background-color: #094ce5 !important
                opacity: .8
                border-bottom-width: 7px !important
            `;
      }
    }}
`;

export default LoginButton;



// WEBPACK FOOTER //
// ./src/views/Auth/components/LoginButton/index.jsx